import { apiService, isVizioTV } from "@blacknut/javascript-sdk/dist";
import { NativeModule } from "./NativeModule";
import electronService from "../../services/ElectronService";

export class NativeBridge {
  private _module?: NativeModule;
  public get module(): NativeModule | undefined {
    return this._module;
  }

  public init() {
    if ("ReactNativeWebView" in window) {
      return import("./AndroidNativeModule").then((mod) => {
        this._module = new mod.AndroidNativeModule();
      });
    } else if (apiService.userAgent.os === "Tizen" && window.parent) {
      return import("./TizenNativeModule").then((mod) => {
        this._module = new mod.TizenNativeModule();
      });
    } else if (apiService.userAgent.os === "Vidaa") {
      return import("./VidaaNativeModule").then((mod) => {
        this._module = new mod.VidaaNativeModule();
      });
    } else if (isVizioTV()) {
      return import("./VizioNativeModule").then((mod) => {
        this._module = new mod.VizioNativeModule();
      });
    } else if (apiService.userAgent.os === "Titanos") {
      return import("./TitanosNativeModule").then((mod) => {
        this._module = new mod.TitanosNativeModule();
      });
    } else if (electronService.isAvailable()) {
      return import("./ElectronNativeModule").then((mod) => {
        this._module = new mod.ElectronNativeModule();
      });
    } else if (
      apiService.userAgent.deviceType === "TV" &&
      process.env.NODE_ENV === "development"
    ) {
      this._module = {
        setUser: () => {
          //NOP,
        },
        setStartUrl: () => {
          //NOP
        },
        exit: () => {
          alert("EXIT");
        },
        handleInAppWebRTC: () => false,
      };
    }
    return Promise.resolve();
  }

  tearDown() {
    this._module?.tearDown?.();
  }
}
